/* SBO v3 announcement bar behaviour: dismiss + sessionStorage, and syncing
   the free-shipping message to the shopper's currency. Loaded once by
   layout/theme.liquid as a deferred script.
   dismissKey is derived from the bar's own DOM id (still rendered by
   Liquid, unchanged) rather than passed in, so this file needs zero
   Liquid-sourced constants of its own beyond window.sboLocale.currency.
   Edit here, not in the section. */

  (() => {
    const bar        = document.querySelector('[data-sbo3-announcement]');
    if (!bar) return;
    const dismissKey = 'sbo3ann_' + bar.id.replace(/^sbov3ann-/, '');
    const rotateMs   = 0;

    /* ── Dismiss ── */
    if (sessionStorage.getItem(dismissKey) === '1') {
      bar.classList.add('is-hidden');
      document.documentElement.style.setProperty('--sbov3-announce-h', '0px');
      return;
    }

    const dismissBtn = bar.querySelector('[data-ann-dismiss]');
    if (dismissBtn) {
      dismissBtn.addEventListener('click', () => {
        bar.classList.add('is-hidden');
        sessionStorage.setItem(dismissKey, '1');
        document.documentElement.style.setProperty('--sbov3-announce-h', '0px');
        const header = document.querySelector('[data-sbo3-header]');
        if (header) header.style.top = '0px';
      });
    }

    /* The free-shipping promise is Canadian only. USD/USA keeps the trust
       message but never substitutes a U.S. threshold into the announcement. */
    const shippingMessages = bar.querySelectorAll('[data-sbo3-announcement-message]');
    function updateAnnouncementShipping(currencyCode) {
      const showShipping = String(currencyCode || '').toUpperCase() === 'CAD';
      shippingMessages.forEach(message => {
        const primary = message.querySelector('.sbov3ann__shipping-primary');
        const separator = message.querySelector('.sbov3ann__shipping-separator');
        message.dataset.shippingVisible = showShipping ? 'true' : 'false';
        if (primary) primary.hidden = !showShipping;
        if (separator) separator.hidden = !showShipping;
      });
    }

    const activeLocale = document.querySelector('[data-sbo3-current-currency]');
    updateAnnouncementShipping(
      activeLocale ? activeLocale.dataset.sbo3CurrentCurrency : window.sboLocale.currency
    );

    window.addEventListener('sbo3:locale-change', event => {
      updateAnnouncementShipping(event.detail && event.detail.currencyCode);
    });

    /* ── Expose height to CSS ── */
    function publishHeight() {
      const h = bar.classList.contains('is-hidden') ? 0 : bar.offsetHeight;
      document.documentElement.style.setProperty('--sbov3-announce-h', h + 'px');
    }
    publishHeight();
    new ResizeObserver(publishHeight).observe(bar);

    /* ── Sale countdown ──
       Shown only inside its window (or before it, when the editor setting
       allows a staging preview). Outside the window the next message takes
       over, so the bar never shows an expired sale. */
    const countdown = bar.querySelector('[data-ann-countdown]');
    if (countdown) {
      const startsAt = Date.parse(countdown.dataset.startsAt);
      const endsAt = Date.parse(countdown.dataset.endsAt);
      const showBeforeStart = countdown.dataset.showBeforeStart === 'true';
      const clock = countdown.querySelector('[data-ann-countdown-clock]');
      const seconds = countdown.querySelector('[data-ann-countdown-seconds]');
      const messages = Array.from(bar.querySelectorAll('[data-ann-msg]'));
      const pad = n => String(n).padStart(2, '0');
      let timer = null;

      function fallBack() {
        clearInterval(timer);
        countdown.classList.remove('is-active');
        const next = messages.find(message => message !== countdown);
        if (next) {
          next.classList.add('is-active');
        } else {
          bar.classList.add('is-hidden');
        }
        publishHeight();
      }

      function tick() {
        const now = Date.now();
        if (Number.isNaN(endsAt) || now >= endsAt || (now < startsAt && !showBeforeStart)) {
          fallBack();
          return;
        }
        const left = Math.floor((endsAt - now) / 1000);
        const days = Math.floor(left / 86400);
        const hours = Math.floor((left % 86400) / 3600);
        const minutes = Math.floor((left % 3600) / 60);
        const secs = left % 60;
        if (!clock) return;
        clock.textContent = (days > 0 ? days + 'd ' : '') + pad(hours) + 'h ' + pad(minutes) + 'm';
        if (seconds) seconds.textContent = ' ' + pad(secs) + 's';
      }

      /* Activation follows the sale window, not block order: whichever message
         the editor sorted first gets is-active at render, so a countdown that
         is not first used to stay dead even inside its window. */
      const now = Date.now();
      const beforeStart = !Number.isNaN(startsAt) && now < startsAt;
      const inWindow = !Number.isNaN(endsAt) && now < endsAt && !(beforeStart && !showBeforeStart);

      if (inWindow) {
        if (!countdown.classList.contains('is-active')) {
          const current = messages.find(message => message !== countdown && message.classList.contains('is-active'));
          if (current) current.classList.remove('is-active');
          countdown.classList.add('is-active');
          publishHeight();
        }
        tick();
        timer = setInterval(tick, 1000);
      } else if (countdown.classList.contains('is-active')) {
        fallBack();
      }
    }

  })();
